module.exports = __webpack_public_path__ + "img/Rollschuhe.e451ca58.png";